export default __webpack_public_path__ + "static/media/woman@2x.21829944.png";